import { tearDownPush } from '~/utils/pushSubscription';

const logout = async (key: string) => {
  if (key === 'token') {
    // Unsubscribe community push notifications on subscriber logout
    await tearDownPush();
  }

  document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  window.location.href = window.location.pathname;
};

export default logout;
